// tslint:disable: max-line-length
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DocumentResourceService } from 'app/document/services/document-resource.service';
import { DocumentModelFactoryService, DocumentModelType, Exercise, PlanDocumentUtils, PlannedTier, ResourceType, RestrictLabel, Workout } from 'fitforce-document-sync';
// tslint:enable: max-line-length

@Component({
  selector: 'document-plan-day-summary',
  templateUrl: './document-plan-day-summary.component.html',
  styleUrls: ['./document-plan-day-summary.component.scss'],
})
export class DocumentPlanDaySummaryComponent implements OnChanges {
    tiers: PlannedTier[] = [];

  @Input() readonly workout: Workout;
  @Input() readonly exercises: Exercise[];
  @Input() readonly restrictLabel?: RestrictLabel;

  @Output() addedToLibrary: EventEmitter<PlannedTier> = new EventEmitter<PlannedTier>();

  get isRestricted() {
    return this.workout && this.workout.restrict_label_id;
  }

  constructor(private resourceService: DocumentResourceService, private factory: DocumentModelFactoryService) {}

  ngOnChanges() {
    this.tiers = [];

    if (this.workout && !this.isRestricted) {
      const workout = this.workout as Workout;
      this.tiers = workout.tiers;

      if (this.tiers.length === 0 ) {
        this.tiers.push(this.factory.build<PlannedTier>(DocumentModelType.PlannedTier));
      }

      this.tiers.forEach(tier => {
        tier.rows = tier.rows.sort(PlanDocumentUtils.sortTiers);
      });
    }
  }

  getVideo(exerciseId: string) {
    const exercise = this.exercises.find(ex => ex.id === exerciseId);
    return this.resourceService.getResource(exercise, ResourceType.Video);
  }

  hasVideo(exerciseId: string): boolean {
    const video = this.getVideo(exerciseId);
    if (video && video.id) {
      return true;
    }
    return false;
  }

  showVideo(exerciseId: string) {
    const exercise = this.exercises.find(ex => ex.id === exerciseId);
    return this.resourceService.showResource(exercise, ResourceType.Video);
  }

  addTierToLibrary(tier: PlannedTier) {
    this.addedToLibrary.emit(tier);
  }
}
